import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, finalize, map, Observable, switchMap, tap } from 'rxjs';
import { UserService } from '../../core/user/user.service';
import { AnalyticsEvent, InternalAnalyticsService } from '../../core/internal-analytics.service';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { SessionService } from '../../core/session.service';

@Component({
    selector: 'rosie-switch-account',
    templateUrl: './switch-account.component.html',
    styleUrls: ['./switch-account.component.scss'],
    standalone: false
})
export class SwitchAccountComponent implements OnInit {
    @ViewChild('switchAccountModal') switchAccountModal: NgxSmartModalComponent;
    searchControl = new FormControl('');
    filteredAccounts: any[] = [];
    selectedAccountId = '';
    isLoadingAccounts = false;
    constructor(
        private analytics: InternalAnalyticsService,
        private modal: NgxSmartModalService,
        private user: UserService,
        private session: SessionService
    ) {
        this.listAllAccounts();
        this.session.refreshState.subscribe(() => this.listAllAccounts());
        this.session.terminate.subscribe(() => this.filteredAccounts = []);
    }

    get activeBusinessId(): string {
        return this.user.activeBusiness?.id
    }

    get hasMultipleBusinesses(): boolean {
        return this.user.hasMultipleBusinesses;
    }

    ngOnInit(): void {
        this.searchControl.valueChanges.pipe(
            debounceTime(250),
            distinctUntilChanged(),
            tap(() => this.analytics.trackEvent(AnalyticsEvent.AccountSearched)),
            switchMap((term) => this.fetchAccounts(term ?? ''))
        ).subscribe();
    }

    listAllAccounts(): void {
        this.fetchAccounts('').subscribe();
    }

    clearSearch() {
        this.searchControl.setValue('');
        this.filteredAccounts = [];
    }

    fetchAccounts(term: string): Observable<any[]> {
        this.isLoadingAccounts = true;
        return this.user.searchBusinesses(term).pipe(
            map(results => {
                this.filteredAccounts = results;
                return results;
            }),
            finalize(() => this.isLoadingAccounts = false)
        );
    }

    switchAccount(account: any) {
        this.selectedAccountId = account.id;
        this.analytics.trackEvent(AnalyticsEvent.AccountSwitched, {
            title: account.title
        });
        this.user.switchToBusiness(account.id).subscribe(() => {
            setTimeout(() => {
                this.selectedAccountId = '';
                this.switchAccountModal.close();
                this.listAllAccounts();
            }, 3000);
        }, () => this.selectedAccountId = '');
    }
}
